// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  padding: 15px 0px 20px;
  text-align: center;
}
.wrapper .cross {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 25px;
  height: 25px;
  z-index: 99;
  cursor: pointer;
}
.wrapper .allert-img {
  margin: 0 auto;
  width: 150px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.wrapper .allert-img ion-icon {
  width: 90px;
  height: 90px;
}
.wrapper .title {
  text-transform: uppercase;
  font-family: AppFontMedium;
  font-size: 24px;
  margin-bottom: 20px;
}
.wrapper .description {
  font-family: AppFontAlt;
  padding: 0 20px;
  margin-bottom: 20px;
}

.footer {
  padding-top: 10px;
}
.footer ion-button {
  width: 90%;
  --border-radius: 50px;
  font-family: AppFontBold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-closed-modal/venue-closed-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,sBAAA;EACA,kBAAA;AACD;AAAC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAEF;AAAC;EACC,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;AAAE;EACC,WAAA;EACA,YAAA;AAEH;AACC;EACC,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;AACF;AACC;EACC,uBAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACC,iBAAA;AACD;AAAC;EACC,UAAA;EACA,qBAAA;EACA,wBAAA;AAEF","sourcesContent":[".wrapper {\n\tposition: relative;\n\tpadding: 15px 0px 20px;\n\ttext-align: center;\n\t.cross {\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tz-index: 99;\n\t\tcursor: pointer;\n\t}\n\t.allert-img {\n\t\tmargin: 0 auto;\n\t\twidth: 150px;\n\t\theight: 110px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 20px;\n\n\t\tion-icon {\n\t\t\twidth: 90px;\n\t\t\theight: 90px;\n\t\t}\n\t}\n\t.title {\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 24px;\n\t\tmargin-bottom: 20px;\n\t}\n\t.description {\n\t\tfont-family: AppFontAlt;\n\t\tpadding: 0 20px;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.footer {\n\tpadding-top: 10px;\n\tion-button {\n\t\twidth: 90%;\n\t\t--border-radius: 50px;\n\t\tfont-family: AppFontBold;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
